<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4></h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <div class="form-group">
        <label>Approval Status</label>
        <select class="form-control" formControlName="approvalStatus" id="approvalStatuses">
          <option value="">Select approval status</option>
          <option *ngFor="let approval of approvalStatuses; let i = index" value="{{ approvalStatuses[i] }}">
            {{ approval }}
          </option>
        </select>
      </div>

      <div *ngIf="approvalStatus === 'APPROVED'" class="form-group">
        <label>Released</label>
        <p-checkbox class="form-control" formControlName="released" binary="true"></p-checkbox>
      </div>

      <div *ngIf="approvalStatus === 'REJECTED'" class="form-group">
        <label>Comment</label>
        <textarea type="text" class="form-control" formControlName="comment"></textarea>
      </div>

      <div class="alert alert-warning" role="alert" *ngIf="!form.valid && (form.dirty || form.touched)">
        <div *ngIf="form.controls['approvalStatus'].errors">
          Please select an Approval Status
        </div>

        <div *ngIf="form.controls['comment'].errors && form.controls['comment'].errors.maxlength">
          Comment cannot be longer than {{ form.controls['comment'].errors.maxlength.requiredLength }} characters
        </div>
        <div *ngIf="form.errors && form.errors.commentRequiredForRejected">
          Please add a comment when rejecting a work order.
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
